import React, { useState } from "react";
import { motion } from "framer-motion";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import Footer from "../components/Footer";

const Contact = () => {
  const [sent, setSent] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSent(true);
    setTimeout(() => setSent(false), 3000);
  };

  return (
    <div className="bg-white text-gray-800 overflow-hidden">
      {/* 🌟 Hero Section */}
      <section
  className="relative text-white py-32 px-6 text-center bg-cover bg-center"
  style={{
    backgroundImage:
      "linear-gradient(rgba(10,37,69,0.6), rgba(13,94,99,0.6)), url('/ct.png')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>

        <motion.h1
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-5xl font-extrabold mb-4 tracking-wide"
        >
          We’re Here to Help You Get Approved — Fast
        </motion.h1>
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 1 }}
          className="text-lg max-w-2xl mx-auto text-gray-200"
        >
          Connect with our financing experts to explore your best options today.  
          Whether you’re rebuilding credit or buying your first car, we’ve got you covered.
        </motion.p>
      </section>

      {/* 📞 Contact Info Cards */}
      <section className="py-20 px-10 md:px-20 grid grid-cols-1 md:grid-cols-3 gap-10 text-center">
        {[
          {
            icon: <FaPhoneAlt className="text-4xl text-teal-400 mb-4" />,
            title: "Call Us",
            detail: "+1(587)920-6970",
          },
          {
            icon: <FaEnvelope className="text-4xl text-teal-400 mb-4" />,
            title: "Email Us",
            detail: "yesautofinance1@gmail.com",
          },
          {
            icon: <FaMapMarkerAlt className="text-4xl text-teal-400 mb-4" />,
            title: "Visit Us",
            detail: "Alberta, Canada",
          },
        ].map((card, i) => (
          <motion.div
            key={i}
            whileHover={{ scale: 1.05 }}
            className="bg-white shadow-xl rounded-2xl py-10 px-6 border-2 border-teal-400/40 hover:shadow-teal-300/50 transition-all duration-300"
          >
            {card.icon}
            <h3 className="text-xl font-bold text-[#0a2545] mb-2">{card.title}</h3>
            <p className="text-gray-600">{card.detail}</p>
          </motion.div>
        ))}
      </section>

      {/* 💬 Contact Form */}
      <section className="py-20 bg-gradient-to-r from-[#0a2545] to-[#0d5e63] text-white text-center relative">
        <motion.div
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mx-auto bg-white/10 backdrop-blur-lg border border-teal-400/30 rounded-3xl p-10 shadow-2xl"
        >
          <h2 className="text-3xl font-bold mb-6">Send Us a Message</h2>
          <form onSubmit={handleSubmit} className="flex flex-col gap-6 text-left">
            <input
              type="text"
              placeholder="Full Name"
              required
              className="p-3 rounded-lg bg-white/20 text-white placeholder-gray-300 border border-white/20 focus:ring-2 focus:ring-teal-400 outline-none"
            />
            <input
              type="email"
              placeholder="Email Address"
              required
              className="p-3 rounded-lg bg-white/20 text-white placeholder-gray-300 border border-white/20 focus:ring-2 focus:ring-teal-400 outline-none"
            />
            <input
              type="tel"
              placeholder="Phone Number"
              required
              className="p-3 rounded-lg bg-white/20 text-white placeholder-gray-300 border border-white/20 focus:ring-2 focus:ring-teal-400 outline-none"
            />
            <textarea
              rows="4"
              placeholder="Your Message..."
              required
              className="p-3 rounded-lg bg-white/20 text-white placeholder-gray-300 border border-white/20 focus:ring-2 focus:ring-teal-400 outline-none"
            ></textarea>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              type="submit"
              className="bg-teal-400 text-[#0a2545] font-semibold py-3 rounded-lg shadow-lg hover:bg-white transition"
            >
              Send Message
            </motion.button>
          </form>
          {sent && (
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="mt-4 text-teal-300 font-semibold"
            >
              ✅ Message Sent Successfully!
            </motion.p>
          )}
        </motion.div>
      </section>

      {/* 🗺️ Alberta Map Section */}
      <section className="relative">
        <iframe
          title="Alberta Location"
          src="https://www.google.com/maps?q=Alberta,Canada&output=embed"
          width="100%"
          height="400"
          allowFullScreen=""
          loading="lazy"
          className="border-none grayscale"
        ></iframe>
        <div className="absolute inset-0 bg-[#0a2545]/40"></div>
      </section>
    </div>
  );
};

export default Contact;
